module.exports = __webpack_public_path__ + "static/media/img3.8d5fe276.jpg";